module.exports = __webpack_public_path__ + "img/badgepreview.3622dc49.png";